import React from "react";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";
import { RangePicker, RangePickerProps } from "rc-picker";
import { FC } from "react";
import { useStore } from "effector-react";
import { getPopupContainer } from "../../shared/getPopupContainer";
import inputStl from "../Input/Input.module.scss";
import cn from "classnames";
import { $currentLocale } from "../../store/shared/locales";

type Props = Omit<RangePickerProps<Date>, "generateConfig" | "locale">;

const DateRange: FC<Props> = ({ className, ...props }) => {
  const { rcPickerLocale: locale } = useStore($currentLocale);

  return (
    <RangePicker<Date>
      className={cn(className, inputStl.block)}
      inputReadOnly
      getPopupContainer={getPopupContainer}
      separator={false}
      {...props}
      locale={locale}
      generateConfig={dateFnsGenerateConfig}
    />
  );
};

export default DateRange;
